import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import type { FC } from "react";

import type { GetUpdatesSource } from "~/feature/auth/type";
import { GetUpdatesForm } from "~/feature/getUpdates/components/GetUpdatesForm";
import { ProofStrip } from "~/feature/getUpdates/components/ProofStrip";
import { useGetUpdatesMetrics } from "~/feature/getUpdates/hooks/useGetUpdatesMetrics";

import * as Styled from "./GetUpdatesContent.styles";

const bullets = [
  {
    lead: "Cross-platform consensus.",
    rest: "Five markets, one clearer probability.",
  },
  {
    lead: "Notable shifts, tracked daily.",
    rest: "What moved, how far, and on what volume.",
  },
  {
    lead: "PredictionHero Indices.",
    rest: "Major themes, distilled into live 0–100 scores.",
  },
];

interface IGetUpdatesContentProps {
  onClose: () => void;
  source: GetUpdatesSource;
}

export const GetUpdatesContent: FC<IGetUpdatesContentProps> = ({
  onClose,
  source,
}) => {
  const proofStripCells = useGetUpdatesMetrics();

  return (
    <Styled.Root>
      <Styled.HeaderRow>
        <Styled.BellTile>
          <NotificationsNoneOutlinedIcon />
        </Styled.BellTile>
        <Styled.Chip>EARLY ACCESS</Styled.Chip>
      </Styled.HeaderRow>
      <Styled.Headline>Odds are moving. See the full picture.</Styled.Headline>
      <Styled.Subhead>
        Polymarket, Kalshi, Opinion, Limitless, and Predict, unified into one
        view.
      </Styled.Subhead>
      <Styled.Bullets>
        {bullets.map(({ lead, rest }) => (
          <Styled.Bullet key={lead}>
            <Styled.BulletCheck>
              <CheckRoundedIcon />
            </Styled.BulletCheck>
            <Styled.BulletText>
              <strong>{lead}</strong> {rest}
            </Styled.BulletText>
          </Styled.Bullet>
        ))}
      </Styled.Bullets>
      <ProofStrip cells={proofStripCells} />
      <GetUpdatesForm onClose={onClose} source={source} />
    </Styled.Root>
  );
};
